export default "__VITE_ASSET__1f67700d__"